import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { Dialog, DialogActions, DialogTitle, DialogContent, ButtonGroup, Button, CircularButton, FlexRow } from './Styles/DownloadInventoryItems';

import { downloadInventoryData } from '../../actions/inventoryActionsV2';
import { ButtonWithLoader } from './Styles/DownloadSupplierProductIds';

const DownloadSupplierProductIds = ({ open, downloadInventoryData, onTrue, onFalse }) => {
	const [downloadingFile, setDownloadingFile] = useState(false);
	const [error, setError] = useState(null);

	const onTrueHandler = async () => {
		setDownloadingFile(true);

		let errorState = {};
		setError(errorState);

		if (Object.keys(errorState).length) {
			setError(errorState);
		} else {
			let fields = ['supplier_product_id', 'name'];

			await downloadInventoryData('download-supplier-product-ids', { fields: fields });
			await onTrue();
		}

		setDownloadingFile(false);
	};

	const onFalseHandler = async () => {
		await onFalse();
	};

	useEffect(() => {
		setError(null);
	}, [open]);

	return (
		<Dialog
			maxWidth='sm'
			fullWidth
			open={open}
			onClose={() => (downloadingFile ? null : onFalseHandler())}
		>
			<DialogTitle>
				Download Item IDs
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						disabled={downloadingFile}
						onClick={() => onFalseHandler()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ marginTop: '-30px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>Download item ids and item names for all inventory items.</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						disabled={downloadingFile}
						onClick={(e) => onFalseHandler()}
					>
						Cancel
					</Button>
					<ButtonWithLoader
						primary
						loading={downloadingFile}
						onClick={(e) => onTrueHandler()}
					>
						Download
					</ButtonWithLoader>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	downloadInventoryData,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DownloadSupplierProductIds);
